import { useContext } from 'react'
import { AuthContext } from '@/modules/auth'

const useAuthContext = () => useContext(AuthContext)

export default useAuthContext

